import { t } from '@lingui/core/macro';
import { TUploadRejectReasonCode } from 'types';

export const translateUploadRejectReason = (
  reasonCode: TUploadRejectReasonCode,
) => {
  switch (reasonCode) {
    case 'ILLEGIBLE':
      return t`Illegible`;
    case 'PASSWORD_PROTECTED':
      return t`Password not available`;
    case 'MISSING_TRANSACTIONS':
      return t`Missing transactions`;
    case 'MISSING_ACCOUNT_DETAILS':
      return t`Missing account details`;
    case 'MISSING_BALANCES':
      return t`Missing balances`;
    case 'INCOMPLETE_REFERENCES':
      return t`References missing`;
    case 'OTHER':
      return t`Other`;
    case 'DUPLICATE':
      return t`Duplicate data`;
    case 'UNSUPPORTED_EXTENSION':
      return t`Invalid extension`;
    case 'UNSUPPORTED_FORMAT':
      return t`Invalid document format`;
    case 'NO_RELEVANT_DATA':
      return t`Relevant data not found`;
    case 'OUTDATED_INFORMATION':
      return t`Outdated information`;
  }
};
